import { SalesOrderStatus } from '../constants/sales-order-status.js';
// WHY: DELIVERED is the live open-AR status (a Shipped order is still on its way), and the as-of rule in load-ar-open-items.ts adds COMPLETE orders closed after T.
export const AR_COUNTABLE_SALES_ORDER_STATUSES = [SalesOrderStatus.DELIVERED];
//# sourceMappingURL=ar-countable-sales-order-statuses.js.map